import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import { loadRoles, isValid, onChangeUserRole, containsUserRole } from '../common.service'
import UserDatasource from '../../../../data/datasource/user.datasource'

const getDefaultState = instance => {
    return {
        saving: false,
        user: {
            id: instance.props.match.params.id,
            firstname: "",
            lastname: "",
            phone: "",
            status: "",
            showUsername: false,
            userRoles: []
        },
        roles: [],
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadUser = instance => {
    UserDatasource().one(instance, {
        id: instance.props.match.params.id
    })
}

const save = instance => {
    axios({
        method: 'post',
        url: API_ENDPOINT + "/user/update",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: instance.state.user
    }).then(response => handleSaveResponse(instance, response)).catch(error => {
        instance.setState({
            ...instance.state,
            saving: false
        })
        alert(error)
    })
}

const handleSaveResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                saving: false,
                flag: {
                    type: "success",
                    text: "Saved successfully"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                saving: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
            alert(response.data.message)
    }
}

const Service = instance => {
    return {
        getDefaultState: () => getDefaultState(instance),
        loadRoles: () => loadRoles(instance),
        isValid: () => isValid(instance),
        onChangeUserRole: roleId => onChangeUserRole(instance, roleId),
        containsUserRole: roleId => containsUserRole(instance, roleId),
        save: () => save(instance),
        loadUser: () => loadUser(instance)
    }
}

export default Service